module.exports = __webpack_public_path__ + "static/media/flag-ca.6627067c.webp";